/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  LessonPlan,
  LessonPlanInput,
  MaterialGeneration,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Generate timetable lesson plan
 */
export const createTimetableLessonPlan = (
    calendarId: MaybeRefOrGetter<string>,
    eventId: MaybeRefOrGetter<string>,
    lessonPlanInput?: MaybeRefOrGetter<LessonPlanInput>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
eventId = toValue(eventId);
lessonPlanInput = toValue(lessonPlanInput);

      return axiosClient<MaterialGeneration>(
      {url: `/timetable/calendars/${calendarId}/events/${eventId}/lesson_plan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lessonPlanInput, signal
    },
      );
    }




export const getCreateTimetableLessonPlanMutationKey = () => ['createTimetableLessonPlan'] as const;

export const getCreateTimetableLessonPlanMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableLessonPlan>>, TError,CreateTimetableLessonPlanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTimetableLessonPlan>>, TError,CreateTimetableLessonPlanMutationVariables, TContext> => {

const mutationKey = getCreateTimetableLessonPlanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTimetableLessonPlan>>, CreateTimetableLessonPlanMutationVariables> = (props) => {
          const {calendarId,eventId,data} = props ?? {};

          return  createTimetableLessonPlan(calendarId,eventId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTimetableLessonPlanMutationResult = NonNullable<Awaited<ReturnType<typeof createTimetableLessonPlan>>>
    export type CreateTimetableLessonPlanMutationBody = LessonPlanInput | undefined
    export type CreateTimetableLessonPlanMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateTimetableLessonPlanMutationVariables = {calendarId: string;eventId: string;data?: LessonPlanInput}

    /**
 * @summary Generate timetable lesson plan
 */
export const useCreateTimetableLessonPlan = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableLessonPlan>>, TError,CreateTimetableLessonPlanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTimetableLessonPlan>>,
        TError,
        CreateTimetableLessonPlanMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTimetableLessonPlanMutationOptions(options), queryClient);
    }
    /**
 * @summary Show timetable lesson plan
 */
export const getTimetableLessonPlan = (
    calendarId: MaybeRefOrGetter<string>,
    eventId: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      calendarId = toValue(calendarId);
eventId = toValue(eventId);

      return axiosClient<LessonPlan>(
      {url: `/timetable/calendars/${calendarId}/events/${eventId}/lesson_plan`, method: 'GET', signal
    },
      );
    }




export const getGetTimetableLessonPlanQueryKey = (calendarId: MaybeRefOrGetter<string>,
    eventId: MaybeRefOrGetter<string>,) => {
    return [
    'timetable','calendars',calendarId,'events',eventId,'lesson_plan'
    ] as const;
    }


export const getGetTimetableLessonPlanQueryOptions = <TData = Awaited<ReturnType<typeof getTimetableLessonPlan>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(calendarId: MaybeRefOrGetter<string>,
    eventId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimetableLessonPlan>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetTimetableLessonPlanQueryKey(calendarId,eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimetableLessonPlan>>> = ({ signal }) => getTimetableLessonPlan(calendarId,eventId, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(calendarId) !== null && toValue(calendarId) !== undefined && toValue(eventId) !== null && toValue(eventId) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimetableLessonPlan>>, TError, TData>
}

export type GetTimetableLessonPlanQueryResult = NonNullable<Awaited<ReturnType<typeof getTimetableLessonPlan>>>
export type GetTimetableLessonPlanQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Show timetable lesson plan
 */

export function useGetTimetableLessonPlan<TData = Awaited<ReturnType<typeof getTimetableLessonPlan>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 calendarId: MaybeRefOrGetter<string>,
    eventId: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimetableLessonPlan>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimetableLessonPlanQueryOptions(calendarId,eventId,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






